import * as React from "react";
const SvgMenu = props => <svg width="inherit" height="inherit" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M4 6H20M4 12H20M4 18H20" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></svg>;
export default SvgMenu;